<div id="wrapper" class="clearfix" [ngClass]="{'main-pages-footer': currentPage !== '/landing' && currentPage !== '/', 'p-b-0': currentPage === '/landing' || currentPage === '/'}" [style]="'padding-bottom: ' + footerHeight + 'px'">
  <ng-content></ng-content>
  <div id="gotoTop" class="icon-angle-up" *ngIf="currentPage !== '/landing' && currentPage !== '/'"></div>
</div>
